<template>
  <!--Start Page Banner-->
  <div class="page-banner-area bg-1">
    <div class="container">
      <div class="page-banner-content">
        <h1>Anti Ragging</h1>
        <ul>
          <li><a href="/">Home</a></li>
          <li>Student Corner</li>
          <li>Policies</li>
          <li>Anti Ragging</li>
        </ul>
      </div>
    </div>
  </div>
  <!--End Page Banner-->

  <!--Start Anti Ragging Area-->
  <div class="privacy-policy-area pt-100 pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="privacy-content pr-20">
            <h2>Anti Ragging Policy</h2>
            <p>Please read this Anti Ragging Policy carefully</p>

            <div class="list">
              <ul>
                <li>
                  <i class="ri-checkbox-line"></i>The Cell attempts to promote
                  and maintain conducive and unprejudiced educational
                  environment for unfettered learning. It is a mechanism for
                  encouraging students to express their Grievances / Problems /
                  Discrimination / Deprivation of any kind regarding the
                  following matters freely without any misgiving or fear of
                  being victimized.
                </li>
                <li>
                  <i class="ri-checkbox-line"></i>The cell redresses the
                  grievances by resolving the problems judiciously and
                  confidentially with promptitude.
                </li>
                <li>
                  <i class="ri-checkbox-line"></i>Vedanta P.G Girls' College,
                  Reengus, is a ragging-free campus. Ragging in any form, direct
                  or indirect, is strictly prohibited and any student, found to
                  be involved in ragging of any nature, will be liable to severe
                  disciplinary action as per law.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="privacy-left-content pl-20">
            <div class="team-img-box">
              <img
                width="460"
                height="500"
                src="vf/images/policies/anti_ragging.png"
                class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                alt=""
                decoding="async"
                fetchpriority="high"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="alumni-area pt-10 pb-70">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="alumni-left-content">
              <div class="related-download">
                <ul>
                  <li>
                    <a
                      href="vf/documents/student_corner/anti_ragging/Anti_Ragging_1.pdf"
                      target="_blank"
                      ><i class="flaticon-search"></i>Anti Ragging 1<span
                        style="float: right"
                        ><strong>Click Here</strong></span
                      ></a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="alumni-right-content">
              <div class="alumni-left-content">
                <div class="related-download">
                  <ul>
                    <li>
                      <a
                        href="vf/documents/student_corner/anti_ragging/Anti_Ragging_2.pdf"
                        target="_blank"
                        ><i class="flaticon-search"></i> Anti Ragging 2<span
                          style="float: right"
                          ><strong>Click Here</strong></span
                        ></a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End Anti Ragging Area-->

  <!-- Start Bottom Connect Area -->
  <div class="alumni-interview-area pb-100">
    <div class="container">
      <div class="interview-content ptb-100">
        <div class="interview">
          <router-link to="antiragging" class="default-btn btn"
            >Mentor Mentee<i class="flaticon-next"></i
          ></router-link>
          <router-link to="/applynow" class="default-btn btn"
            >Apply Now</router-link
          >
        </div>
      </div>
    </div>
  </div>
  <!--End Bottom Connect Area -->
</template>

<script>
export default {
  name: "AntiRaggingView",
};
</script>
